import institutionalPages from "./institutionalPages.json";

export default institutionalPages;
